/* cg-track.js (Round 30, Oct 10 2026). Funnel tracking the apps miss, loaded sitewide from snippets/card-description-clamp.liquid.
   Google Ads account: California Grill 863-280-5505, tag AW-957825907.
   1. Menu item views. Dishes open in a sheet, not a product page, so Klaviyo (browse abandonment) and Meta never saw a view.
   2. Lead forms (reservations, rewards, catering quote, catering accounts) are Shopify forms. Shopify keeps the lead, but
      Klaviyo, Google Ads and Meta never heard about it. On submit: Klaviyo identify + event, Ads conversion, Meta Lead.
   3. Click to call and directions: Google Ads + Klaviyo signals for the "ready to come in" guest.
   R50 (Oct 17 2026): dish views also go to GA4 G-7VXKDMYNF0 (the property the Google & YouTube app feeds with
   add_to_cart, checkout and purchase), so GA4 sees the whole menu funnel. Add to cart, checkout and purchase stay
   with the apps (Google & YouTube, Facebook & Instagram, Pinterest): sending them here too would double count.
   4. Klaviyo "Added to Cart". Menu adds are AJAX (/cart/add.js) and the Klaviyo app does not see them (checked Oct 17:
      no Klaviyo call on add). This sends Klaviyo's standard Added to Cart event so the cart abandonment flow can catch
      guests who add a dish and leave before checkout. Klaviyo only records it for a known profile.
   R72 (Nov 4 2026): the AW config call waits for window.cgLater (first interaction or 10 s after load). Running it at
   page start made the already loaded Google tag process it on the spot, a 235 ms main thread task in PageSpeed. */
(function () {
  'use strict';
  var AW = 'AW-957825907';
  var GA4 = 'G-7VXKDMYNF0';
  var LEAD_LABEL = AW + '/pBePCOjN4P0cEPOG3cgD'; /* "Catering Quote Click" (Request quote goal) */

  function kl(fn) { try { if (window.klaviyo) fn(window.klaviyo); else { window._learnq = window._learnq || []; fn(null); } } catch (e) {} }
  function gt() { try { if (typeof window.gtag === 'function') window.gtag.apply(null, arguments); } catch (e) {} }
  function fb() { try { if (typeof window.fbq === 'function') window.fbq.apply(null, arguments); } catch (e) {} }
  (window.cgLater || function (f) { f(); })(function () { gt('config', AW); });

  /* 1. item views */
  var lastCard = null, lastView = '';
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-product-id]'); if (c) lastCard = c;
    var a = e.target.closest && e.target.closest('a[href]'); if (!a) return;
    var h = a.getAttribute('href') || '';
    if (/^tel:/i.test(h)) {
      gt('event', 'click_to_call', { send_to: AW });
      kl(function (k) { if (k) k.track('Clicked To Call', { page: location.pathname }); });
      fb('track', 'Contact');
    } else if (/maps\.google|google\.com\/maps|maps\.apple|goo\.gl\/maps/i.test(h)) {
      gt('event', 'get_directions', { send_to: AW });
      kl(function (k) { if (k) k.track('Clicked Directions', { page: location.pathname }); });
      fb('track', 'FindLocation');
    }
  }, true);
  function trackView() {
    var sh = document.querySelector('.cgm-sheet.is-open'); if (!sh) { lastView = ''; return; }
    var h = sh.querySelector('h2,h3,.cgm-sheet__title'), name = h ? h.textContent.trim() : ''; if (!name || name === lastView) return;
    lastView = name;
    var pid = lastCard ? lastCard.getAttribute('data-product-id') : '', img = lastCard && lastCard.querySelector('img'), a = lastCard && lastCard.querySelector('a[href*="/products/"]');
    var pm = (sh.textContent.match(/\$\s?(\d+(?:\.\d\d)?)/) || [])[1], price = pm ? +pm : undefined;
    var item = { ProductName: name, ProductID: pid, ImageURL: img ? (img.currentSrc || img.src) : '', URL: a ? a.href : location.href, Price: price, Categories: ['Menu'] };
    kl(function (k) {
      if (!k) return;
      k.track('Viewed Product', item);
      if (k.trackViewedItem) k.trackViewedItem({ Title: name, ItemId: pid, ImageUrl: item.ImageURL, Url: item.URL, Metadata: { Price: price } });
    });
    fb('track', 'ViewContent', { content_ids: [pid], content_name: name, content_type: 'product', value: price, currency: 'USD' });
    gt('event', 'view_item', { send_to: AW, value: price, currency: 'USD', items: [{ id: pid, google_business_vertical: 'retail' }] });
    gt('event', 'view_item', { send_to: GA4, value: price, currency: 'USD', items: [{ item_id: pid, item_name: name, item_category: 'Menu', price: price, quantity: 1 }] });
  }
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(trackView, 150); })
    .observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['class'] });

  /* 2. lead forms */
  var FORMS = {
    'cgf-res': { ev: 'Requested Reservation', lead: false, src: 'reservation' },
    'cgf-rew': { ev: 'Joined Rewards Waitlist', lead: false, src: 'rewards' },
    'cgc-quote-form': { ev: 'Requested Catering Quote', lead: true, src: 'catering-quote' },
    'cgf-acct': { ev: 'Applied for Catering Account', lead: true, src: 'catering-account' }
  };
  function val(f, re) { var el = [].slice.call(f.elements).filter(function (x) { return re.test(x.name || ''); })[0]; return el ? (el.value || '').trim() : ''; }
  function phoneE164(p) { var d = (p || '').replace(/\D/g, ''); if (d.length === 10) return '+1' + d; if (d.length === 11 && d.charAt(0) === '1') return '+' + d; return ''; }
  /* Shopify form posts reload the page, so the lead is parked on submit and sent once the page comes back with
     contact_posted / customer_posted = true (Shopify's success marker). A failed post is never counted. */
  var PK = 'cg_lead_pending';
  document.addEventListener('submit', function (e) {
    var f = e.target, cfg = f && FORMS[f.id]; if (!cfg) return;
    var email = val(f, /\[email\]$/i), name = val(f, /\[(name|first_name)\]$/i), last = val(f, /\[last_name\]$/i), phone = phoneE164(val(f, /\[phone\]$/i));
    var props = { source: cfg.src, page: location.pathname };
    [].slice.call(f.elements).forEach(function (x) {
      var m = /^contact\[(.+)\]$/.exec(x.name || ''); if (!m || /email|phone|body|tags|name/i.test(m[1]) || (x.type === 'hidden' && m[1] !== 'Request type')) return;
      if (x.value) props[m[1]] = x.value;
    });
    var who = email ? { email: email } : null;
    if (who) {
      if (name) who.first_name = name.split(' ')[0];
      if (last) who.last_name = last; else if (name.indexOf(' ') > 0) who.last_name = name.split(' ').slice(1).join(' ');
      if (phone) who.phone_number = phone;
      if (props.Organization) who.organization = props.Organization;
    }
    try { sessionStorage.setItem(PK, JSON.stringify({ id: f.id, who: who, props: props, t: Date.now() })); } catch (err) {}
  }, true);
  function flushLead() {
    var p = null; try { p = JSON.parse(sessionStorage.getItem(PK) || 'null'); } catch (e) {}
    if (!p || Date.now() - p.t > 600000) return;
    if (!/(contact|customer)_posted=true/.test(location.search)) return;
    try { sessionStorage.removeItem(PK); } catch (e) {}
    var cfg = FORMS[p.id]; if (!cfg) return;
    var go = function (k) { if (p.who) k.identify(p.who); k.track(cfg.ev, p.props); };
    if (window.klaviyo) go(window.klaviyo); else { var n = 0, iv = setInterval(function () { if (window.klaviyo) { clearInterval(iv); go(window.klaviyo); } else if (++n > 40) clearInterval(iv); }, 250); }
    if (cfg.lead) { gt('event', 'conversion', { send_to: LEAD_LABEL }); gt('event', 'generate_lead', { send_to: GA4, lead_source: cfg.src }); fb('track', 'Lead', { content_name: cfg.ev }); }
    else { gt('event', 'generate_lead', { send_to: AW }); gt('event', 'generate_lead', { send_to: GA4, lead_source: cfg.src }); fb('track', cfg.src === 'rewards' ? 'CompleteRegistration' : 'Schedule'); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', flushLead); else flushLead();

  /* 4. Klaviyo Added to Cart for AJAX adds */
  function addedToCart(added) {
    var first = (added && (added.items ? added.items[0] : added)) || null; if (!first || !first.product_title && !first.title) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var items = (c.items || []).map(function (i) { return { ProductID: i.product_id, VariantID: i.variant_id, SKU: i.sku, ProductName: i.product_title, Quantity: i.quantity, ItemPrice: i.final_price / 100, RowTotal: i.final_line_price / 100, ProductURL: location.origin + i.url, ImageURL: i.image }; });
      kl(function (k) {
        if (!k) return;
        k.track('Added to Cart', {
          $value: c.total_price / 100,
          AddedItemProductName: first.product_title || first.title, AddedItemProductID: first.product_id, AddedItemSKU: first.sku,
          AddedItemImageURL: first.image, AddedItemURL: first.url ? location.origin + first.url : location.href,
          AddedItemPrice: (first.final_price || first.price || 0) / 100, AddedItemQuantity: first.quantity,
          ItemNames: items.map(function (i) { return i.ProductName; }), CheckoutURL: location.origin + '/cart', Items: items,
          OrderType: (c.attributes || {})['Order Type'] || '', Channel: (c.attributes || {})['Channel'] || ''
        });
      });
    }).catch(function () {});
  }
  var of = window.fetch;
  if (of && !of.__cgTrackAdd) {
    var w = function (input) {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(u)) p.then(function (r) { if (r && r.ok) r.clone().json().then(addedToCart).catch(function () {}); }).catch(function () {});
      return p;
    };
    Object.keys(of).forEach(function (k) { w[k] = of[k]; }); w.__cgTrackAdd = true; window.fetch = w;
  }
})();
